module.exports = __webpack_public_path__ + "static/media/PxGroteskLightItalic.54300cc1.ttf";